/* tslint:disable */
/* eslint-disable */
export enum OpgaveEnum {
  NotSet = 'NotSet',
  Eftersyn = 'Eftersyn',
  Tilkald = 'Tilkald',
  Opfoelgning = 'Opfoelgning',
  Opstart = 'Opstart'
}
